export default [
  {
    "id": 1,
    "url": "https://www.truecaller.com/year-in-calling-2019",
    "fb": "See how the world communicated through Truecaller in 2019!",
    "tw": "See how the world communicated through @Truecaller in 2019! https://tclr.se/2rLh8Bl",
    "wa": "See how the world communicated through Truecaller in 2019! Take a look! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/1.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/1.png"
  },
  {
    "id": 2,
    "url": "https://www.truecaller.com/year-in-calling-2019/2",
    "fb": "Truecaller helped save us from 199 million spam calls in 2019! #YearinCalling",
    "tw": "Hey @Truecaller! Thanks for saving us from 199 million spam calls in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "Truecaller helped save us from 199 million spam calls in 2019! Check it out! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/2.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/2.png"
  },
  {
    "id": 3,
    "url": "https://www.truecaller.com/year-in-calling-2019/3",
    "fb": "Truecaller blocked and identified 26 billion spam calls in 2019! #YearinCalling",
    "tw": "@Truecaller blocked and identified 26 billion spam calls in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "Truecaller blocked and identified 26b spam numbers in 2019! Take a look! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/3a.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/3a.png"
  },
  {
    "id": 4,
    "url": "https://www.truecaller.com/year-in-calling-2019/4",
    "fb": "Truecaller blocked and identified 8.6 billion spam SMS in 2019! #YearinCalling",
    "tw": "@Truecaller blocked and identified 8.6 billion spam SMS in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "Truecaller blocked and identified 8.6 billion spam SMS in 2019! Take a look! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/4.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/4.png"
  },
  {
    "id": 5,
    "url": "https://www.truecaller.com/year-in-calling-2019/5",
    "fb": "Guess who is the most spammed country in the world? Truecaller\"s #YearinCalling has the details.",
    "tw": "Guess who is the most spammed country in the world? @Truecaller\"s #YearinCalling has the details. https://tclr.se/2rLh8Bl",
    "wa": "Guess who is the most spammed country in the world? Truecaller\"s Year in Calling has the details. https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/5.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/5.png"
  },
  {
    "id": 6,
    "url": "https://www.truecaller.com/year-in-calling-2019/6",
    "fb": "Can you believe one spammer from India made 109 million calls in a year? Take a look!",
    "tw": "Can you believe one spammer from India made 109 million calls in a year? Take a look at @Truecaller\"s #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "Can you believe one spammer from India made 109 million calls in a year? Take a look at Truecaller\"s Year in Calling https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/6.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/6.png"
  },
  {
    "id": 7,
    "url": "https://www.truecaller.com/year-in-calling-2019/7",
    "fb": "In 2019, 1 out of 3 women in India receive sexual and inappropriate calls or SMS. Time to say #ItsNotOK #YearinCalling",
    "tw": "In 2019, 1 out of 3 women in India receive sexual and inappropriate calls or SMS. Time to say #ItsNotOK #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "In 2019, 1 out of 3 women in India receive sexual and inappropriate calls or SMS. Time to say #ItsNotOK #YearinCalling https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/7.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/7.png"
  },
  {
    "id": 8,
    "url": "https://www.truecaller.com/year-in-calling-2019/8",
    "fb": "Truecaller is much more than a caller ID app. In 2019, Truecaller helped solve cases around the world. Check it out. ",
    "tw": "See @Truecaller\"s impact and how it helped solve cases around the world in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "See Truecaller\"s impact and how it helped solve cases around the world in 2019! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/8.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/8.png"
  },
  {
    "id": 9,
    "url": "https://www.truecaller.com/year-in-calling-2019/9",
    "fb": "Fast fact: The Truecaller Community is made up of 150 million people who use Truecaller every day. See more from their #YearinCalling",
    "tw": "Fast fact: The Truecaller Community is made up of 150 million people who use Truecaller every day. See more facts from their #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "Fast fact: The Truecaller Community is made up of 150 million people who use Truecaller every day. See more facts from their Year in Calling. https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/9.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/9.png"
  },
  {
    "id": 10,
    "url": "https://www.truecaller.com/year-in-calling-2019/10",
    "fb": "See how the world communicated with Truecaller in 2019! #YearinCalling",
    "tw": "See how the world communicated with Truecaller in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "See how the world communicated with Truecaller in 2019! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/10.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/10.png"
  },
  {
    "id": 11,
    "url": "https://www.truecaller.com/year-in-calling-2019/11",
    "fb": "See how the world communicated with Truecaller in 2019! #YearinCalling",
    "tw": "See how the world communicated with Truecaller in 2019! #YearinCalling https://tclr.se/2rLh8Bl",
    "wa": "See how the world communicated with Truecaller in 2019! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/11.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/11.png"
  },
  {
    "id": 12,
    "url": "https://www.truecaller.com/year-in-calling-2019/12",
    "fb": "Which country talked the most in 2019? Check out Truecaller\"s #YearinCalling to find out!",
    "tw": "Which country talked the most in 2019? Check out Truecaller\"s #YearinCalling to find out! https://tclr.se/2rLh8Bl",
    "wa": "Which country talked the most in 2019? Check out Truecaller\"s Year in Calling to find out! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/12.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/12.png"
  },
  {
    "id": 13,
    "url": "https://www.truecaller.com/year-in-calling-2019/13",
    "fb": "See how the world communicated through Truecaller in 2019!",
    "tw": "See how the world communicated through @Truecaller in 2019! https://tclr.se/2rLh8Bl",
    "wa": "See how the world communicated through Truecaller in 2019! Take a look! https://tclr.se/2rLh8Bl",
    "ogImage": "https://www.truecaller.com/year-in-calling-2019/img/open-graph/13.png",
    "twImage": "https://www.truecaller.com/year-in-calling-2019/img/twitter/13.png"
  }
]